import { createClient } from "@supabase/supabase-js";
import config from "../../config";

export const supabase = createClient(
  config.auth.SUPABASE_URL,
  config.auth.SUPABASE_PUBLIC_KEY
);
